<script setup>
const emit = defineEmits(['click'])
const props = defineProps({
    active: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        default: ''
    }
})
</script>

<template>
    <button :class="[
        'group border hover:border-accent px-4 py-2 rounded-lg',
        props.active ? 'bg-surface-active border-primary' : 'bg-surface-primary border-secondary']" @click="emit('click')">
        <div class="[&>svg]:stroke-accent group-hover:[&>svg]:stroke-accent size-6" :aria-label="props.label">
            <slot></slot>
        </div>
    </button>
</template>